import React from 'react'
import '../App.css'
import Bodymovwalletreport from './bodymovwalletreport'
export class Bodyappmovwalletreportbody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className="flex flex-row space-x-4"> {/* flex-row organiza los elementos horizontalmente */}
                <Bodymovwalletreport/>
            </div>    
        );
    }
}